import { ActionIcon, Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const LabelVisibilityToggle = () => {
    const { showHeatmapLabels, setShowHeatmapLabels } = usePlacementStore(
        useShallow((state) => ({
            showHeatmapLabels: state.showHeatmapLabels,
            setShowHeatmapLabels: state.setShowHeatmapLabels
        }))
    );

    return (
        <div className="flex shrink-0 items-center justify-center px-1 sm:px-1">
            <Tooltip
                label={showHeatmapLabels ? 'Hide labels' : 'Show labels'}
                position="bottom"
                variant={variants.tooltip.bottom}
            >
                <ActionIcon
                    aria-label={showHeatmapLabels ? 'Hide labels' : 'Show labels'}
                    className="bg-background-transparent hover:bg-background-gray! pointer-events-auto action-icon-medium"
                    variant={showHeatmapLabels ? variants.actionIcon.activated : undefined}
                    onPointerDown={() => setShowHeatmapLabels(!showHeatmapLabels)}
                >
                    label
                </ActionIcon>
            </Tooltip>
        </div>
    );
};
